/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-unexpected-error',
  templateUrl: './unexpected-error.component.html'
})
export class UnexpectedErrorComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
